module.exports = "<span>{{data&&data!=''?data:'-'}}</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/nbinput/nbinput-label.component.html
// module id = 164
// module chunks = 0 1